import { useCallback, useEffect } from 'react';
import { isE2E } from 'src/utils/e2e/isE2E';
import { isSeoCrawler } from 'src/utils/seo/isSeoCrawler';
import useFTUEStorage from './useFTUEStorage';
export default function useFTUE(key, events = {}, forcedValue) {
    const [state, setState] = useFTUEStorage(key);
    const markComplete = useCallback(() => {
        setState(false);
    }, []);
    const suppress = isSeoCrawler || isE2E;
    useEffect(() => {
        if (suppress || state !== true) {
            return;
        }
        events.onFTUE && events.onFTUE(markComplete);
    }, [state, markComplete]);
    return [suppress ? false : forcedValue ?? state, { markComplete }];
}
